import naja from "naja";
import { initArtistMultiselect } from "../Artist/artistMultiselect";
import { createApp } from "vue";
import ReportContainer from "../Report/ReportContainer.vue";
import { initFlatPickr } from "../Flatpickr";
import { initCitySelects } from "../Concert/citySelect";
import Modal from "bootstrap/js/dist/modal";
import {initTooltips} from "../initTooltips";


naja.initialize();
initArtistMultiselect();
initCitySelects();
initFlatPickr();


function initReports() {
	const reports = document.querySelectorAll('[data-vue-report]');

	reports.forEach(report => createApp(ReportContainer).mount(report));
}

initReports();

let modals = [];
function initModals() {
	const modalElements = document.querySelectorAll('.modal');

	modalElements.forEach(modal => {
		const modalInstance = Modal.getInstance(modal);

		if (modalInstance) {
			modalInstance.hide();
			modalInstance.dispose();
		}

		modals.push(
			new Modal(modal, {
				keyboard: false,
				focus: false,
			})
		);
	});
}

naja.addEventListener('before', (event) => {
	const activeModalElement = document.querySelector('.modal.show');
	const activeModal = Modal.getInstance(activeModalElement);

	if (activeModal) {
		activeModal.hide();
	}
});

naja.addEventListener('complete', function () {
	initModals();
	initArtistMultiselect();
	initReports();
	initFlatPickr();
	initCitySelects();
	initTooltips();
})
